// extracted by mini-css-extract-plugin
export default {"item_wrapper":"VariantItem_item_wrapper__vinMA","image_wrapper":"VariantItem_image_wrapper__Qf9Ga","title":"VariantItem_title__tv-8k","active":"VariantItem_active__7z70c"};